<template>
</template>

<script>
export default {
    components: {},
    data: function () { },
    mounted: function () {
        window.location.href = "/kj/bind/to-bind"
    },
    methods: {},
};
</script>
